const brocolli = () => {
	const headerbox = document.querySelectorAll('.header-box');
	[...headerbox].forEach((box) => {
		box.onmouseenter = () => {
			box.classList.add('over')
		}
		box.onmouseleave = () => {
			box.classList.remove('over')
		}
	});
}
document.addEventListener('DOMContentLoaded', brocolli);